/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Breadcrumbs, Typography, Button } from '@material-ui/core'

import EventGroupList from './components/EventGroupList'


const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

class EventPicker extends Component {
    state = {
        anchorEl : null
    }

    togglePopper = (event) => {
        if (this.state.anchorEl === null) {
            this.setState({
                ...this.state,
                anchorEl : event.currentTarget
            })
        } else {
            this.setState({
                ...this.state,
                anchorEl : null
            })
        }
    }

    renderEventGroupList = () => {
        if (this.state.anchorEl !== null) {
            console.log("Event Group Anchor :", this.state.anchorEl)
            return (
                <EventGroupList anchorEl = {this.state.anchorEl} push_event = {(event_name) => this.pushEvent(event_name)} />
            )
        }
    }

    pushEvent = (event_name) => {
        this.setState({
            ...this.state,
            anchorEl : null
        }, () => this.props.update_value(this.props.instance.id, "text", event_name))     
    }

    render() {
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper variant = 'outlined' style = {{width : '100%', height : '100%', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1, height : '100%'}}>
                        <Typography variant = 'caption' color = 'primary'>{this.props.instance.name}</Typography>
                        {this.props.instance.value.text === null || this.props.instance.value.text.length === 0 ? 
                        <Typography color = 'textSecondary'><em>Choose an event.</em></Typography> : 
                        <Typography>{this.props.instance.value.text}</Typography>}
                    </div>
                    <Button color = 'primary' size = 'small' onClick = {this.togglePopper} >Select Event</Button>
                </Paper>
               {this.renderEventGroupList()}
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(EventPicker);